import {
    EMETLAssessmentTools,
} from "../Model/EMETLAssessment.m"
// import EMETLAssessmentTools from "../Model/EMETLAssessment.m"

export type StyleModel = {
    container: object,
    light: object,
    dark: object,
}

export type EMETLAssessmentTableRow = [
    ID: {
        title: number,
    }, 
    title: {
        title: string,
        subtitle?: string,
    }, 
    createdDate: {
        title: string,
    }, 
    createdTime: {
        title: string,
    }, 
    trainingType: {
        title: string,
    }, 
    assessor: {
        title: string,
    },
]
export class ViewAssessments extends EMETLAssessmentTools {
    /*** Private Members ***/
    
    #tableHeaders: string[] = [
        "ID", 
        "Title", 
        "Date", 
        "Time", 
        "Training Type", 
        "Assessor"
    ]
    
    /*** Protected Members ***/
    
    /*** Private Methods ***/
    
    /*** Protected Methods ***/
    
    /**
     * Initialize and perform setup for the class
     */
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        // Perform additional setup here...
    }
    
    /*** Public Methods ***/
    
    /**
     * Class constructor. Calls _init() on the superclass. Add parameters as needed
     */
    public constructor() {
        super()
        this._init()
    }
    
    public get tableHeaders(): string[] {
        return this.#tableHeaders
    }
    
}

// Instantiate the VM and export the instance
const ViewAssessmentsVM = new ViewAssessments()

export default ViewAssessmentsVM
